export default "__VITE_ASSET__CkCy2mKx__"